import React from "react";
import { usePlayerNumEntries } from "../util/db";
import { Card, Row, Col } from "react-bootstrap";
import { usePlayerNumEvents } from "../util/db";
import AllTimeThrowScoreStats from "./AllTimeThrowScoreStats";

function DashboardStats(props) {
  const uid = props.uid;

  // const playersScore = usePlayerScore(uid);
  // const playersFives = usePlayerFives(uid);
  const playersEntries = usePlayerNumEntries(uid);
  const playersEvents = usePlayerNumEvents(uid);

  return (
    <Card className="mb-3">
      <Card.Header style={{ background: "#2D083F", color: "white" }}>
        <Card.Title className="mb-0" style={{ color: "white" }}>
          Player Statistics
        </Card.Title>
      </Card.Header>
      <Card.Body style={{ background: "#FFFFFF" }}>
        <Row>
          {/* General Stats Section */}
          <Col md={6} className="mb-4">
            <div className="mb-3 pb-3 border-bottom">
              <strong className="text-muted d-block mb-2">
                📊 General Statistics
              </strong>

              <div className="mb-3">
                <div className="d-flex justify-content-between align-items-center">
                  <span className="text-muted">Total Plays</span>
                  <span
                    className="h6 mb-0 fw-bold"
                    style={{ color: "#495057" }}
                  >
                    {playersEntries}
                  </span>
                </div>
              </div>

              <div className="mb-0">
                <div className="d-flex justify-content-between align-items-center">
                  <span className="text-muted">Total Events</span>
                  <span
                    className="h6 mb-0 fw-bold"
                    style={{ color: "#495057" }}
                  >
                    {playersEvents}
                  </span>
                </div>
              </div>
            </div>
          </Col>

          {/* Throw Accuracy Section */}
          <Col md={6} className="mb-4">
            <div className="mb-3">
              <strong className="text-muted d-block mb-2">
                🎯 Throw Accuracy
              </strong>
              <div className="mt-2">
                <AllTimeThrowScoreStats uid={uid} />
              </div>
            </div>
          </Col>
        </Row>
      </Card.Body>
      <Card.Footer
        style={{
          background: "#2D083F",
          color: "white",
        }}
      />
    </Card>
  );
}

export default DashboardStats;
